import React from "react";
import { LinkButton, AbtaLogo, AtolLogo, FlowBox } from "../../../../core/atoms/atoms";
import { CallToActionBlock } from "../../../components/ctaBlock/ctaBlock";
import { RoutesInvoker } from "../../../routesInvoker";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./locationUpsellBlock.scss";

export class LocationUpsellBlock extends React.PureComponent<{ locations: ILocation[] }> {

  private getImage(locations: ILocation[]): string {
    // #1531 Get the first "review footer" or "hero" image from attached locations
    const images = locations
      .map(l => (l.images || [])
        .filter(i => i.locationImageType === LocationImageType.ReviewFooter
          || i.locationImageType === LocationImageType.Hero))
      .reduce((a, b) => a.concat(b), [])
      .sort((a, b) => b.locationImageType - a.locationImageType); // Desc to prioritise review footer

    return images.length ? images[0].largeUrl : "/images/missing-image.jpg";
  }

  public render() {
    if (!this.props.locations) {
      return null;
    }
    const locations = (this.props.locations || []).filter(l => l.locationType === LocationType.Country);
    const heroImageUrl = this.getImage(locations);
    const enquireFormParams = {
      locationSlug: locations.length > 0 ? locations[0].slug : null,
      campaign: "review-foot",
    };

    return (
      <CallToActionBlock backgroundImage={heroImageUrl} boxAlignX="left" boxAlignY="top">
        <div className="location-upsell">
          <header>
            <h1 className="heading--2">Experience it yourself</h1>
            <p>
              When it comes to planning your perfect trip, our trusted local experts are here to help.
              Whether you prefer to travel in luxury or off the beaten path, they have the knowledge and experience to design a fantastic tailor-made holiday, just for you.
            </p>
          </header>

          <LinkButton to={WebRoutes.enquiryForm(enquireFormParams)} buttonClass="primary-button" className="text--regular text--light">
            Plan my trip
          </LinkButton>

          <div className="location-upsell__trust">
            <div className="location-upsell__trust__logos">
              <AbtaLogo type="colour" height={45} />
              <AtolLogo type="dark" width={70} />
            </div>
            <LinkButton to={WebRoutes.aboutHowItWorks()} buttonClass="secondary-button" className="text--dark">
              How does TravelLocal work?
              </LinkButton>
          </div>
          <div className="clearfix" />
        </div>
      </CallToActionBlock>
    );
  }
}